<template>
  <div class="gift-form h-100">
    <div class="row row-narrow mt-4">
      <div :class="{ 'col-md-4': !standalone, 'col-md-12': standalone }">
        <InputGroup v-model="name"
                    class="mb-0"
                    :show-errors="true"
                    validation-id="name"
                    :placeholder="$t('name')"/>
      </div>
      <div :class="{ 'col-md-4': !standalone, 'col-md-12': standalone }">
        <InputGroup v-model="phone"
                    class="mb-0"
                    :show-errors="true"
                    validation-id="phone"
                    :placeholder="$t('phone')"/>
      </div>
      <div :class="{ 'col-md-4': !standalone, 'col-md-12': standalone }">
        <button class="gift-btn btn btn-themed btn-themed-squared w-100"
                @click="submit">
          {{ $t('send') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup.vue"
import { MarketingService } from "@/services/api/marketing.api.service"
import { getCurrentInstance, onBeforeMount, onMounted, ref } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  userId: {
    type: String,
    required: true
  },
  standalone: {
    type: Boolean,
    default: false
  }
})

const store = useStore()

let i18n = null
let noty = null

const name = ref('')
const phone = ref('')

const RECAPTCHA_SITE_KEY = '6LfOf3EiAAAAAMkAOQH7VRvj6_X7A3v50q7pNKcs'

const loadRecaptcha = () => {
  if(window.grecaptcha) return Promise.resolve()
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`
    script.async = true
    script.defer = true
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}

const getRecaptchaToken = async () => {
  await loadRecaptcha()
  return new Promise(resolve => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'gift_form'}).then(resolve)
    })
  })
}

onBeforeMount(() => {
  i18n = (getCurrentInstance())?.ctx?.$i18n
  noty = getCurrentInstance()?.appContext?.app?.noty
})

onMounted(() => {
  if(props.standalone) {
    loadRecaptcha()
  }
})

const submit = async () => {
  store.commit('cleanValidationErrors')
  try {
    const res = await MarketingService.submitGiftApplication({
      name: name.value,
      phone: phone.value,
      uid: props.userId,
      ...(props.standalone ? {recaptcha_token: await getRecaptchaToken()} : {})
    })
    if(res.data) {
      name.value = ''
      phone.value = ''
      noty.info(i18n.t('success_message'))
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<style scoped lang="scss">
.gift-btn {
  height: 46px;
}
</style>
